/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import _ from 'lodash';
import React from 'react';

import { request } from '@mairistem/tools';

import { BASE_URL_ETATCIVIL } from '@/constants/url';
import type { CategorieAnts, OptionCodeAnts } from '@/types';

const URL_CATEGORIES_ANTS = `${BASE_URL_ETATCIVIL}/mention-ants/categories`;

/**
 * Option « Code ANTS » d'une catégorie, au format court attendu (AD-12846) :
 * « 403 - Nom, prénoms et sexe - Changement de nom par décret ».
 */
export const optionCodeAnts = (categorie: CategorieAnts): OptionCodeAnts => ({
  key: Number(categorie.codeRefAnts),
  value: Number(categorie.codeRefAnts),
  text: _.compact([
    categorie.codeRefAnts,
    categorie.type,
    categorie.sousType,
  ]).join(' - '),
});

/**
 * Charge les catégories ANTS quand `actif` passe à `true` (à l'ouverture d'une
 * modale de mention) et en dérive les options du dropdown « Code ANTS ».
 *
 * Une option par CATÉGORIE, valeur = son code : c'est ce que l'ETCV propose,
 * stocke dans `mm_code_mention_ants` et affiche (AD-12850). Proposer chaque
 * mention du référentiel multipliait les entrées, et faisait écrire un rang
 * que l'ETCV ne reconnaissait pas.
 */
const useOptionsCodeAnts = (actif: boolean) => {
  const [options, setOptions] = React.useState<OptionCodeAnts[]>([]);
  const [loading, setLoading] = React.useState(false);

  React.useEffect(() => {
    if (!actif) {
      setOptions([]);
      return;
    }

    setLoading(true);
    request
      .get<unknown, { data: CategorieAnts[] }>(URL_CATEGORIES_ANTS)
      .then(({ data: categories }: { data: CategorieAnts[] }) => {
        setOptions(_.map(categories, optionCodeAnts));
      })
      .finally(() => {
        setLoading(false);
      });
  }, [actif]);

  return { options, loading };
};

export default useOptionsCodeAnts;
